import { SignIn } from "@clerk/clerk-react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

export default function SignInPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {!isMobile && (
        <Box
          sx={{
            flex: 1,
            backgroundColor: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
          }}
        >
          <Stack spacing={4} sx={{ maxWidth: 600, textAlign: "center" }}>
            <Box
              component="img"
              src="/logo-yellow.svg"
              alt="desplega.ai"
              sx={{
                height: 48,
                alignSelf: "center",
                mb: 2,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              <Box component="span" sx={{ color: "white" }}>
                Stop Trading <br /> Quality for{" "}
              </Box>
              <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                Speed
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                fontWeight: 400,
                lineHeight: 1.2,
              }}
            >
              Modern QA is giving your team the tools to get instant feedback, not bottlenecks, so
              you can confidently iterate faster and scale without breaking. Desplega.ai transforms
              QA from a release gatekeeper into a devex powerhouse.
            </Typography>
          </Stack>
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          backgroundColor: "white",
        }}
      >
        <SignIn signInUrl="/sign-in" signUpUrl="/sign-up" forceRedirectUrl="/" />
      </Box>
    </Box>
  );
}
